angular.module('myApp.newsRoom', ['ngRoute'])


    .config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {


        $routeProvider.when('/newsroom', {
            templateUrl: 'components/newsRoom/newsRoom.html',
            controller: 'newsRoomCtrl'
        })
          }])

       .controller('newsRoomCtrl', ['$scope','$window','$sce',function( $scope, $window,$sce) {
            $window.scrollTo(0, 0);
           $("#menu").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           $("#fatafat").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           $("#meals").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           $("#delivery").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           $("#feed").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           $("#rides").css({'border-bottom':'0px solid  #595968', 'padding-bottom':'3px'});
           var imgsrc = "images/pressmedia/";
           
            $scope.pressMediaObject = [
                {
                    link:'https://www.forexnewsnow.com/top-stories/interview-samar-singla-jugnoo/',
                    desc:"Samar Singla's interview with ForexNewsNow Dubai.",
                    img: imgsrc +  'fn_logo.png',
                    date:new Date(2019,3,10),

                    heading: 'Forex News Now'
                },
                {
                    link:'https://timesofindia.indiatimes.com/city/bengaluru/app-based-autorickshaw-services-in-city-help-reduce-dead-mileage/articleshow/68382387.cms',
                    desc:"Jugnoo featured in Times of India",
                    img: imgsrc + 'toi.png',
                    date:new Date(2019,2,13),

                    heading: 'The Times of India'
                },
                {
                    link:'https://www.entrepreneur.com/article/326185',
                    desc:"Samar Singla’s quote in Entrepreneur India story on Why Chandigarh is an Ideal Breeding Ground for Startups?",
                    img: imgsrc + 'I_27.png',
                    date:new Date(2019,0,12),

                    heading: 'The entrepreneur'
                },
                {
                    link:'https://www.tribuneindia.com/news/business/big-boost-to-small-town-dreams/673737.html',
                    desc:"Jugnoo has been featured among Chandigarh based startup that managed to Scout funds from MNC’s and other big investors.",
                    img: imgsrc +  'ti_logo.jpg',
                    date:new Date(2018,9,26),

                    heading: 'The Tribune India'
                },
                {
                    link:'https://www.entrepreneur.com/article/321541',
                    desc:"Jugnoo’s view on How The Agenda of Safety First Can Change The Game For Ride-hailing Companies.",
                    img: imgsrc + 'I_27.png',
                    date:new Date(2018,9,11),

                    heading: 'The Entrepreneur'
                },
                {
                    link:'https://www.straitstimes.com/singapore/transport/indian-firm-jugnoo-and-local-player-kardi-team-up-to-fight-ride-hailing-battle',
                    desc:"Jugnoo joined hands with a local player Kardi to fight the ride hailing battle in Singapore.",
                    img: imgsrc +  'straightTimes.png',
                    date:new Date(2018,7,12),

                    heading: 'The Straits Times'
                },
                {
                    link:'https://auto.economictimes.indiatimes.com/news/aftermarket/app-based-transport-service-in-tripura-soon-minister/65161949',
                    desc:"Jugnoo Selected by the Government in Tripura, Agartala",
                    img: imgsrc +  'economicTimes.png',
                    date:new Date(2018,6,27),

                    heading: 'The Economic Times'
                },
                {
                    link:'https://gulfnews.com/business/sectors/technology/jugnoo-india-s-third-largest-ride-hailing-app-to-foray-into-uae-1.2249286',
                    desc:"Jugnoo, India’s third-largest ride-hailing app to foray into UAE",
                    img: imgsrc +  'gulf.jpeg',
                    date:new Date(2018,6,21),

                    heading: 'The Gulf News'
                },
                {
                    link:'https://www.straitstimes.com/business/jugnoos-cab-hailing-betting-on-transparency-for-success-in-singapore',
                    desc:"Jugnoo's cab-hailing betting on transparency for success in Singapore",
                    img: imgsrc +  'straightTimes.png',
                    date:new Date(2018,5,19),

                    heading: 'The Straits Times'
                },
                {
                    link:'http://www.htsyndication.com/htsportal/ht-lucknow/article/jugnoo-join-hands-with-larts-to-relaunch-autos/27772225',
                    desc:"Jugnoo join hands with LARTS to relaunch autos in Lucknow",
                    img: imgsrc +  'HTSyndication.png',
                    date:new Date(2018,4,31),

                    heading: 'HTSyndication'
                },
                {
                    link:'https://techcrunch.com/2018/04/25/jugnoo-singapore-uber-void/',
                    desc:"India’s Jugnoo adopts a unique take on ride-hailing to help fill Singapore’s Uber void",
                    img: imgsrc +  'TechCrunch.png',
                    date:new Date(2018,3,25),

                    heading: 'Tech Crunch'
                },
                {
                    link:'http://www.businessworld.in/article/Jugnoo-Launches-an-On-demand-3D-Printing-Store-Printo-/26-02-2018-141788/',
                    desc:"Jugnoo Launches an On-demand 3D Printing Store 'Printo'",
                    img: imgsrc +  'business_world_logo.png',
                    date:new Date(2018,1,26),

                    heading: 'Business World'
                },
                {
                    link:'https://www.youtube.com/watch?v=c46sRt9bAWk',
                    desc:"ET Now - Leaders of Tomorrow series featuring Jugnoo.",
                    img: imgsrc +  'ET-Now.jpeg',
                    date:new Date(2018,1,17),

                    heading: 'ET Now'
                },
                {
                    link:'https://m.dailyhunt.in/news/india/english/business+sandesh+english-epaper-bussanen/jugnoo+launches+its+business+tools+in+the+auto+expo+2018-newsid-81538255',
                    desc:"Jugnoo launches its business tools in The Auto Expo",
                    img: imgsrc +  'daily_hunt.png',
                    date:new Date(2018,1,10),

                    heading: 'Daily Hunt'
                },
                {
                    link:'https://www.insightssuccess.in/jugnoo-providing-an-instant-access-to-reliable-and-affordable-service',
                    desc:"Jugnoo: Providing an Instant Access to Reliable and Affordable Services",
                    img: imgsrc +  'insights_logo.png',
                    date:new Date(2018,1),

                    heading: 'Insights Success'
                },
                {
                    link:'https://www.covaipost.com/coimbatore/3-coimbatore-women-auto-drivers-awarded/',
                    desc:"Jugnoo women drivers awarded ‘Women of achievement’ by Rotary Club of Monarks, Coimbatore",
                    img: imgsrc +  'covai_post_logo.png',
                    date:new Date(2018,0,24),

                    heading: 'The Covai Post'
                },
                {
                    link:'http://www.businessworld.in/article/Riding-On-India-s-Growth-Wave/18-01-2018-137687/',
                    desc:"Riding On India’s Growth Wave - Samar Singla’s interview with BW Businessworld.",
                    img: imgsrc +  'business_world_logo.png',
                    date:new Date(2018,0,18),

                    heading: 'Business World'
                },

                {
                    link:'https://in.news.yahoo.com/jugnoo-announces-launch-cabs-chandigarh-113734399.html',
                    desc:"Jugnoo announces launch of cabs in Chandigarh",
                    img: imgsrc +  'I_5.png',
                    date:new Date(2017,11,1),
                    preference: 0
                },
                {
                    link:'https://thenortheasttoday.com/arunachal-pradesh-jugnoo-an-auto-hailing-app-gears-up-to-make-inroads-into-northeast-india-through-itanagar/',
                    desc:"Jugnoo- an auto hailing app gears up to make inroads into Northeast India through Itanagar!",
                    img: imgsrc + 'tnt-magazine-logon.png',
                    date:new Date(2017,10,23),
                    preference: 0
                },
                {
                    link:'https://www.indianweb2.com/2017/11/13/jugnoo-delivers-pollution-masks-comes-rescue-delhiites/',
                    desc:"Jugnoo Delivers Pollution Masks, Comes To The Rescue of Delhiites",
                    img: imgsrc + 'indian-web-logo.png',
                    date:new Date(2017,10,13),
                    preference: 0
                },

                {
                    link:'http://www.business-standard.com/article/news-ani/jugnoo-introduces-concierge-service-fatafat-117110901182_1.html',
                    desc:"Jugnoo introduces concierge service - Fatafat",
                    img: imgsrc + 'business_standard.jpeg',
                    date:new Date(2017,10,9),
                    preference: 0
                },
                {
                    link:'https://www.mid-day.com/articles/as-tomatoes-hit-rs-100-per-kg-chandigarh-hyper-local-transport-and-logistics-app-jugnoo-offers-re-1/18705160',
                    desc:"Tomato Loot! Jugnoo Delivers Tomato At Just Re 1 Per Kg In Chandigarh",
                    img: imgsrc + 'mid-day-logo.png',
                    date:new Date(2017,10,2),
                    preference: 0
                },
                {
                    link:'https://www.outlookindia.com/newsscroll/jugnoo-adds-bicycles-to-its-delivery-vertical/1166308',
                    desc:"Jugnoo adds bicycles to its delivery vertical ",
                    img: imgsrc + 'outlook-logo.jpg',
                    date:new Date(2017,9,11),
                    preference: 0
                },
                {
                    link:'https://www.thememo.com/2017/10/03/uber-for-tuk-tuks-jugnoo-ceo-samar-singla-taxi-apps-click-labs-tuktuk-apps/',
                    desc:"How an Uber for tuk-tuks quietly took over the world",
                    img: imgsrc + 'it-memo-logo.ico',
                    date:new Date(2017,9,3),
                    preference: 0
                },

                {
                    link:'http://www.itnewsbuzz.com/how-jugnoo-is-changing-its-logistics-game-with-ai/',
                    desc:"How Jugnoo is changing its Logistics game with AI",
                    img: imgsrc + 'itnewsbuzz-logo.jpg',
                    date:new Date(2017,8,19),
                    preference: 0
                },

                {
                    link:'http://www.businesstoday.in/magazine/features/the-geeky-auto-company/story/257809.html',
                    desc:"The Geeky Auto Company- Jugnoo is now on a steady ride ",
                    img: imgsrc + 'logo-btoday.png',
                    date:new Date(2017,7,21),
                    preference: 0
                },
                {
                    link:'http://bwcio.businessworld.in/article/Jugnoo-Announces-Partnership-with-CloudTRACK/21-08-2017-124357/',
                    desc:"Jugnoo Announces Partnership with CloudTRACK",
                    img: imgsrc + 'CIO_logo.png',
                    date:new Date(2017,7,27),
                    preference: 0
                },
                {
                    link:'http://zeenews.india.com/companies/jugnoo-launches-partnership-program-for-b2b-products-2031798.html',
                    desc:"Jugnoo launches partnership program for B2B products",
                    img: imgsrc + 'zeenews.png',
                    date:new Date(2017,7,10),
                    preference: 0
                },
                {
                    link:'https://in.news.yahoo.com/jugnoo-launches-fugu-real-time-customer-support-app-074651901.html',
                    desc:"Jugnoo launches Fugu - real time customer support app ",
                    img: imgsrc + 'I_5.png',
                    date:new Date(2017,7,1),
                    preference: 0
                },
                {
                    link:'https://www.medianama.com/2017/07/223-jugnoo-bumbl-launch/',
                    desc:"Jugnoo enters business services segment with a new SaaS product- Bumbl   ",
                    img: imgsrc + 'medianama.png',
                    date:new Date(2017,6,27),
                    preference: 0
                },
                {
                    link:'http://economictimes.indiatimes.com/small-biz/startups/jugnoo-becomes-finalist-in-k-startup-grand-challenge-in-korea/printarticle/59753997.cms',
                    desc:"Jugnoo becomes finalist in K-Startup grand challenge in Korea ",
                    img: imgsrc + 'I_2.png',
                    date:new Date(2017,6,25),
                    preference: 0
                },
                {
                    link:'https://www.gqindia.com/content/gqs-influential-young-indians-2017-innovators/#samar-singla-and-chinmay-agarwal',
                    desc:"Samar Singla and Chinmay Agarwal featured in GQ Magazine among 50 Most Influential Young ",
                    img: imgsrc + 'gq.png',
                    date:new Date(2017,6,7),
                    preference: 0
                },
                {
                    link:'http:// https://yourstory.com/2017/07/conversations-samar-singla-jugnoo/',
                    desc:"Obsession with outcomes puts fear in you: Samar Singla, Founder, Jugnoo  ",
                    img: imgsrc + 'ys.png',
                    date:new Date(2017,6,6),
                    preference: 0
                },
                {
                    link:'https://www.techinasia.com/jugnoo-turns-cash-positive',
                    desc:"Jugnoo becomes India’s first on-demand transportation app to turn cash positive ",
                    img: imgsrc + 'techa.png',
                    date:new Date(2017,5,30),
                    preference: 0
                },

                {
                    link:'http://www.business-standard.com/article/news-ani/jugnoo-takes-a-big-leap-in-restaurant-aggregation-117052600937_1.html',
                    desc:"Jugnoo takes a big leap in restaurant aggregation    ",
                    img: imgsrc + 'I_1.png',
                    date:new Date(2017,4,26),
                    preference: 0
                },

                {
                    link:'https://yourstory.com/2017/05/jugnoo-menus/',
                    desc:"Jugnoo’s Menus eyes food delivery space in 21 tier-2 and 3 cities    ",
                    img: imgsrc + 'ys.png',
                    date:new Date(2017,4,25),
                    preference: 0
                },
                {
                    link:'http://e24.no/naeringsliv/delingsoekonomi/sjefen-for-indias-uber-paa-jakt-etter-ansatte-i-norge/23998583',
                    desc:"The head of \"India\'s Uber\" hunts employees in Norway      ",
                    img: imgsrc + 'e24.jpg',
                    date:new Date(2017,4,17),
                    preference: 0
                },
                {
                    link:'http://www.nyteknikk.no/Indiske-Jugnoo-klar-for-Skandinavia',
                    desc:"Indian Jugnoo ready for Scandinavia      ",
                    img: imgsrc + 'NyTeknikkLogo.jpg',
                    date:new Date(2017,4,15),
                    preference: 0
                },
                {
                    link:'https://www.bloombergquint.com/technology/2017/05/13/meet-bengalurus-first-delivery-woman',
                    desc:"Meet Bengaluru’s First Delivery Woman       ",
                    img: imgsrc + 'bloomberg.jpg',
                    date:new Date(2017,4,13),
                    preference: 0
                },
                {
                    link:'http://www.business-standard.com/article/news-ani/jugnoo-celebrates-mother-s-day-with-unspokenlove-117050900869_1.html',
                    desc:"Jugnoo celebrates Mother's Day with #unspokenLove       ",
                    img: imgsrc + 'business_standard.jpeg',
                    date:new Date(2017,4,9),
                    preference: 0
                },
                {
                    link:'https://www.telegraphindia.com/pressrelease/nv/58928/jugnoo-announces-special-offers-on-food-orders-for-the-ipl-s.html',
                    desc:"Jugnoo Announces Special Offers on Food Orders for the IPL Season this Year       ",
                    img: imgsrc + 'telegraph.gif',
                    date:new Date(2017,4,1),
                    preference: 0
                },
                {
                    link:'https://in.news.yahoo.com/jugnoo-announces-special-offers-food-orders-ipl-season-123938082.html ',
                    desc:"Jugnoo Announces Special Offers on Food Orders for the IPL Season this Year       ",
                    img: imgsrc + 'I_5.png',
                    date:new Date(2017,4,1),
                    preference: 0
                },

             {
           link:'http://www.business-standard.com/article/news-ians/auto-rickshaw-aggregator-jugnoo-ties-up-with-oye-taxi-and-scootapp-116011200640_1.html',
           desc:"Auto-rickshaw aggregator Jugnoo ties up with Oye Taxi and Scootapp    ",
           img: imgsrc + 'I_1.png',
           date:new Date(2016,0,12),
           preference: 0
           },

             {
           link:'http://economictimes.indiatimes.com/wealth/earn/jugnoo-starts-up-auto-rickshaw-aggregation-business/articleshow/50508796.cms',
           desc:"Jugnoo starts up auto-rickshaw aggregation business  ",
           img: imgsrc + 'I_2.png',
           date:new Date(2016,0,11),
           preference: 0
           },
           {
           link:'http://www.dnaindia.com/money/report-jugnoo-to-enroll-female-drivers-registers-first-in-noida-2163219',
           desc:"Jugnoo to enroll female drivers, registers first in Noida",
           img: imgsrc + 'I_3.png',
           date:new Date(2016,0,7),
           preference: 0
       },
     {
           link:'http://www.financialexpress.com/article/companies/jugnoo-to-enroll-female-drivers-registers-first-in-noida/189861/',
           desc:"Jugnoo to enroll female driver’s, registers first in Noida ",
           img: imgsrc + 'I_4.png',
           date:new Date(2016,0,7),
           preference: 0
       },

{
           link:'https://in.news.yahoo.com/jugnoo-enroll-female-drivers-registers-first-noida-120710377.html',
           desc:"Jugnoo to enroll female driver's, registers first in Noida ",
           img: imgsrc + 'I_5.png',
           date:new Date(2016,0,7),
           preference: 0
       },

{
           link:'http://computer.financialexpress.com/photos/gadget-gallery/oddeven-movement-in-delhi-top-5-apps-to-tap-from-jugnoo-ola-to-blablacar/15185-5/',
           desc:"#OddEven Movement in Delhi: Top 5 apps to tap, from Jugnoo, Ola to BlaBlaCar ",
           img: imgsrc + 'I_6.png',
           date:new Date(2015,0,5),
           preference: 0
       },
{
           link:'http://computer.financialexpress.com/news/oddevenformula-paytm-backed-jugnoo-accelerates-autorides-in-delhi/15173/',
           desc:"#Oddevenformula:  Paytm-backed Jugnoo accelerates autorides in Delhi  ",
           img: imgsrc + 'I_7.png',
           date:new Date(2016,0,4),
           preference: 0
       },
{
           link:'https://in.news.yahoo.com/paytm-jugnoo-collaborate-help-delhi-embrace-odd-even-082538988.html',
           desc:"Paytm, Jugnoo collaborate to help Delhi embrace Odd-Even formula  ",
           img: imgsrc + 'I_5.png',
           date:new Date(2016,0,4),
           preference: 0
       }
,
{
           link:'http://www.dnaindia.com/money/report-odd-even-scheme-auto-rickshaw-aggregator-jugnoo-to-offer-100-cashback-more-offers-2162118',
           desc:"Odd-even scheme: Auto-rickshaw aggregator Jugnoo to offer 100% cashback, more offers  ",
           img: imgsrc + 'I_3.png',
           date:new Date(2016,0,4),
           preference: 0
       }
       ,
{
           link:'http://inc42.com/buzz/news-roundup-61/',
           desc:"Paytm, Jugnoo Join Hands  ",
           img: imgsrc + 'inc.png',
           date:new Date(2016,0,2),
           preference: 0
       }
       ,
{
           link:'http://www.business-standard.com/article/current-affairs/odd-even-plan-car-pooling-service-radio-cabs-comes-to-commuters-aid-116010100256_1.html',
           desc:"Odd-even scheme: Demand for app-based cabs, autos soars; e-bikes likely to be deployed soon  ",
           img: imgsrc + 'I_1.png',
           date:new Date(2016,0,2),
           preference: 0
       }
       ,
{
           link:'http://www.btvin.com/videos/watch/15834/jugnoo--autos-just-a-click-away-',
           desc:"Jugnoo: Autos Just A Click Away!  ",
           img: imgsrc + 'I_12.png',
           date:new Date(2016,0,1),
           preference: 0
       }
,
{
           link:'http://www.business-standard.com/article/current-affairs/delhi-s-odd-even-plan-options-for-delhi-commuters-115123100641_1.html',
           desc:"Delhi's odd-even plan: Options for Delhi commuters ",
           img: imgsrc + 'I_1.png',
           date:new Date(2015,11,31),
           preference: 0
       }
,
{
           link:'http://articles.economictimes.indiatimes.com/2015-12-31/news/69426725_1_paytm-cashback-private-vehicles',
           desc:"Paytm and Jugnoo partner to offer Delhi consumers cashback offers during city’s odd-even traffic restrictions ",
           img: imgsrc + 'I_2.png',
           date:new Date(2015,11,31),
           preference: 0
       }
,
{
           link:'http://techcrunch.com/gallery/uber-and-beyond-12-transportation-on-demand-services-in-asia/',
           desc:"12 Transportation On-Demand Services In Asia  ",
           img: imgsrc + 'I_15.png',
           preference: 0,
           date:new Date(2015,11,28)
       }
,
{
           link:'http://yourstory.com/2015/12/odd-even-traffic-rule/',
           desc:"Transport services startups look to take advantage of odd-even traffic rule in Delhi  ",
           img: imgsrc + 'I_16.png',
           preference: 0,
           date:new Date(2015,11,21)
       }
,
{
           link:'http://www.hindustantimes.com/noida/new-mobile-app-makes-hiring-autorickshaws-easier-in-noida/story-qt9bN0vaxhadR72RMcuezJ.htm',
           desc:"New mobile app makes hiring autorickshaws easier in Noida  ",
           img: imgsrc + 'I_17.png',
           preference: 0,
           date:new Date(2015,11,21)
       }
,
{
           link:'http://www.thehindubusinessline.com/catalyst/scaling-as-an-underdog/article7969873.ece',
           desc:"Scaling as an underdog  ",
           img: imgsrc + 'I_18.png',
           preference: 0,
           date:new Date(2015,11,10)
       }
,
{
           link:'http://articles.economictimes.indiatimes.com/2015-12-10/news/68930983_1_8-cities-three-more-cities-uber',
           desc:"Jugnoo partners with Zophop to help customers in making best travel decisions  ",
           img: imgsrc + 'I_2.png',
           preference: 0,
           date:new Date(2015,11,10)
       }
,
{
           link:'http://www.thehindu.com/todays-paper/tp-business/auto-finance/article7959257.ece',
           desc:"Jugnoo partners PNB and Piaggio  ",
           img: imgsrc + 'I_20.png',
           preference: 0,
           date:new Date(2015,11,8)
       }
,
{
           link:'http://articles.economictimes.indiatimes.com/2015-12-07/news/68835806_1_piaggio-auto-drivers-auto-rickshaw',
           desc:"Jugnoo partners Punjab National Bank, Piaggio for easy auto finance  ",
           img: imgsrc + 'I_2.png',
           preference: 0,
           date:new Date(2015,11,7)
       }
,
{
           link:'http://www.business-standard.com/article/companies/jugnoo-raises-3million-in-series-b-funding-115111700743_1.html',
           desc:"Jugnoo raises $3 million in series B funding  ",
           img: imgsrc + 'I_1.png',
           preference: 0,
           date:new Date(2015,10,18)
       }
,
{
           link:'http://articles.economictimes.indiatimes.com/2015-11-17/news/68356481_1_paytm-series-b-funding-autos',
           desc:"Jugnoo raises $3 million in Series B funding from Paytm  ",
           img: imgsrc + 'I_2.png',
           preference: 0,
           date:new Date(2015,10,17)
       }
,
{
           link:'http://www.thehindubusinessline.com/info-tech/jugnoo-closes-3-mn-series-b-funding-led-by-paytm/article7887837.ece',
           desc:"Jugnoo closes $3 mn series ‘B’ funding led by Paytm  ",
           img: imgsrc + 'I_18.png',
           preference: 0,
           date:new Date(2015,10,17)
       }
,
{
           link:'http://www.financialexpress.com/article/industry/companies/jugnoo-closes-3-million-funding-from-paytm-others/166873/',
           desc:"Jugnoo closes $3 million funding from Paytm, others (FE)  ",
           img: imgsrc + 'I_4.png',
           preference: 0,
           date:new Date(2015,10,17)
       }

,
{
           link:'http://www.vccircle.com/news/technology/2015/11/17/jugnoo-gets-3m-series-b-funding-paytm-others',
           desc:"Jugnoo gets $3M in Series B funding from Paytm, others  ",
           img: imgsrc + 'I_26.png',
           preference: 0,
           date:new Date(2015,10,17)
       }
,
{
           link:'http://www.entrepreneur.com/article/252237',
           desc:"Solving common man's problems' – A cliché working well for startups  ",
           img: imgsrc + 'I_27.png',
           preference: 0,
           date:new Date(2015,9,29)
       },


        {
            link:'http://techcrunch.com/2015/06/05/jugnoo/',
            desc:'On-Demand App Jugnoo Gets $5M To Bring India’s Auto Rickshaws Online ',
            img: imgsrc + 'tc.png',
            date:new Date(2015,5,5),
            preference: 0
        },
        {
            link:'http://economictimes.indiatimes.com/small-biz/startups/jugnoo-raises-5-million-from-snow-leopard-ventures-paytm/articleshow/47552996.cms',
            desc:'Jugnoo raises $5 million from Snow Leopard Ventures, Paytm ',
            img: imgsrc + 'et.png',
            date:new Date(2015,5,5),
            preference: 1
        },
        {
            link:'http://www.business-standard.com/article/companies/autorickshaw-app-now-gets-cabs-too-115080300002_1.html',
            desc:'Autorickshaw app, now gets cabs, too',
            img: imgsrc + 'business_standard.jpeg',
            date:new Date(2015,7,3),
            preference: 2

        },
        {
            link:'http://www.business-standard.com/article/companies/onion-crisis-makes-cheap-marketing-tool-for-chandigarh-startup-115082400642_1.html',
            desc:'Onion crisis makes cheap marketing tool for Chandigarh startup',
            img: imgsrc + 'business_standard.jpeg',
            date:new Date(2015,7,24),
            preference: 2
        },
        {
            link:'http://timesofindia.indiatimes.com/city/indore/Now-dial-an-auto-service-soon/articleshow/49298479.cms',
            desc:'Now, dial an auto service soon',
            img: imgsrc + 'toi.png',
            date:new Date(2015,9,10),
            preference: 3
        },
        {
            link:'http://yourstory.com/2015/09/jugnoo-to-launch-in-philippines/',
            desc:'Jugnoo jumps from 100K to 300K transaction within 100 days, to launch in Philippines soon',
            img: imgsrc + 'ys.png',
            date: new Date(2015,8,18),
            preference: 4
        },
//new links
//
//
  {
    link:'http://www.dnaindia.com/money/report-jugnoo-clocks-all-time-high-of-10000-rides-a-day-across-delhi-ncr-region-2190074',
    desc:'Jugnoo clocks all-time high of 10,000 rides a day across Delhi NCR region',
    img: imgsrc + 'I_3.png',
    date:new Date(2016,2,16),
    preference: 4
  },
  {link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-launches-emergency-tracking-single-tap-booking-on-its-app/51330101',
    desc:'Jugnoo launches emergency tracking, single tap booking on its app',
    img: imgsrc + 'I_2.png',
    date:new Date(2016,2,9),
    preference: 4
  },

  {link:'http://www.business-standard.com/article/news-ani/jugnoo-updates-app-with-emergency-tracking-single-tap-booking-116030900274_1.html',
    desc:'Jugnoo updates app with emergency tracking, single tap booking',
    img: imgsrc + 'I_1.png',
    date:new Date(2016,2,9),
    preference: 4
  },

  {link:'http://economictimes.indiatimes.com/small-biz/startups/jugnoo-slashes-fares-by-rs-5-for-customer-acquisition/articleshow/51092782.cms',
    desc:'Jugnoo slashes fares by Rs 5 for customer acquisition ',
    img: imgsrc + 'I_2.png',
    date:new Date(2016,1,22),
    preference: 4
  },

  {link:'http://www.thehindu.com/features/metroplus/download-the-jugnoo-app-to-enjoy-a-hassle-free-auto-ride-in-coimbatore/article8261167.ece',
    desc:'Click and ride',
    img: imgsrc + 'I_20.png',
    date:new Date(2016,1,20),
    preference: 4
  },

  {link:'http://timesofindia.indiatimes.com/life-style/relationships/man-woman/5-utility-apps-that-come-in-handy-for-women/articleshow/51037057.cms',
    desc:'5 utility apps that come in handy for women',
    img: imgsrc + 'toi.png',
    date:new Date(2016,1,18),
    preference: 4
  },

  {link:'http://economictimes.indiatimes.com/small-biz/entrepreneurship/actress-soumya-tandon-becomes-investor-brand-ambassador-of-ride-sharing-app-jugnoo/articleshow/50992631.cms',
    desc:'Actress Soumya Tandon becomes investor, brand ambassador of ride-sharing app Jugnoo ',
    img: imgsrc + 'I_2.png',
    date:new Date(2016,1,15),
    preference: 4
  },

  {link:'http://www.thehindubusinessline.com/economy/logistics/actress-saumya-tandon-is-jugnoos-brand-ambassador/article8240833.ece',
    desc:'Actress Saumya Tandon is Jugnoo’s brand ambassador',
    img: imgsrc + 'I_20.png',
    date:new Date(2016,1,15),
    preference: 4
  },

  {link:'http://www.financialexpress.com/article/tech/auto-rickshaw-aggregator-jugnoo-to-expand-to-1000-villages/210537/',
    desc:'Auto rickshaw aggregator Jugnoo to expand to 1,000 villages',
    img: imgsrc + 'I_4.png',
    date:new Date(2016,1,12),
    preference: 4
  },


  {link:'http://www.business-standard.com/article/news-ani/jugnoo-now-available-on-windows-phone-116020500397_1.html',
    desc:'Jugnoo now available on Windows Phone',
    img: imgsrc + 'I_1.png',
    date:new Date(2016,1,5),
    preference: 4
  },


  {link:'https://in.news.yahoo.com/apps-newcomer-city-130605832.html',
    desc:'Apps for a newcomer in the city',
    img: imgsrc + 'I_5.png',
    date:new Date(2016,1,4),
    preference: 4
  },

  {link:'http://timesofindia.indiatimes.com/city/coimbatore/New-call-auto-firm-makes-inroads-in-Coimbatore/articleshow/50755510.cms',
    desc:'New call-auto firm makes inroads in Coimbatore',
    img: imgsrc + 'toi.png',
    date:new Date(2016,0,28),
    preference: 4
  },




  {link:'http://www.financialexpress.com/article/industry/companies/a-firefly-in-auto-aggregation-business/201370/',
    desc:'A firefly in auto aggregation business',
    img: imgsrc + 'I_4.png',
    date:new Date(2016,0,28),
    preference: 4
  },

  {link:'http://techcrunch.com/2016/01/22/jugnoo-series-b/',
    desc:'India’s Jugnoo Closes $5.5M Series B For Its Auto-Rickshaw On-Demand Service',
    img: imgsrc + 'I_15.png',
    date:new Date(2016,0,25),
    preference: 4
  },

  {link:'http://www.thehindu.com/news/national/karnataka/expansion-plans-on-the-anvil/article8137956.ece',
    desc:'Expansion plans on the anvil',
    img: imgsrc + 'I_20.png',
    date:new Date(2016,0,22),
    preference: 4
  },


  {link:'http://www.thehindu.com/news/national/karnataka/booking-an-auto-just-got-easy-in-mysuru/article8137950.ece',
    desc:'Booking an auto just got easy in Mysuru',
    img: imgsrc + 'I_20.png',
    date:new Date(2016,0,22),
    preference: 4
  },

  {link:'http://articles.economictimes.indiatimes.com/2016-01-20/news/69931057_1_series-b-funding-paytm-auto-rickshaw',
    desc:'Auto rickshaw aggregator Jugnoo raises $5.5 million in Series-B funding',
    img: imgsrc + 'I_2.png',
    date:new Date(2016,0,20),
    preference: 4
  },
{link:'http://www.business-standard.com/article/news-ani/jugnoo-foodpanda-tie-up-for-online-food-ordering-delivery-116050600572_1.html',
            desc:'Jugnoo, Foodpanda tie-up for online food ordering, delivery',
            img: imgsrc + 'I_1.png',
            date:new Date(2016,4,6),
            preference: 4
        },
        {link:'http://retail.economictimes.indiatimes.com/news/food-entertainment/food-services/jugnoo-foodpanda-tie-up-for-online-food-ordering-delivery/52148899',
            desc:'Jugnoo, Foodpanda tie-up for online food ordering, delivery',
            img: imgsrc + 'I_2.png',
            date:new Date(2016,4,6),
            preference: 4
        },

        {
            link:'http://economictimes.indiatimes.com/magazines/panache/jugnoo-launches-new-service-to-book-auto-ride-via-facebook-messenger/articleshow/52093710.cms',
            desc:'Jugnoo launches new service to book auto ride via Facebook messenger ',
            img: imgsrc + 'I_2.png',
            date:new Date(2016,4,3),
            preference: 4
        },
        {
            link:'http://www.business-standard.com/article/news-ani/auto-drivers-can-now-recharge-customers-paytm-wallet-instead-of-giving-change-116050200756_1.html',
            desc:'Auto drivers can now recharge customers" Paytm wallet instead of giving change ',
            img: imgsrc + 'I_1.png',
            date:new Date(2016,4,2),
            preference: 4
        },
        {
            link:'http://timesofindia.indiatimes.com/city/delhi/Auto-drivers-can-now-recharge-customers-Paytm-wallet-instead-of-giving-change/articleshow/52076724.cms',
            desc:'Auto drivers can now recharge customers" Paytm wallet instead of giving change ',
            img: imgsrc + 'toi.png',
            date:new Date(2016,4,2),
            preference: 4
        },
        {
            link:'http://auto.economictimes.indiatimes.com/news/aftermarket/commuters-can-now-book-jugnoo-autos-via-ixigo-cabs/52038659',
            desc:'Commuters can now book Jugnoo autos via ixigo cabs ',
            img: imgsrc + 'I_2.png',
            date:new Date(2016,3,28),
            preference: 4
        },
        {
            link:'http://www.thehindubusinessline.com/info-tech/now-book-jugnoo-autos-via-ixigo/article8533300.ece',
            desc:'Now, book Jugnoo autos via ixigo ',
            img: imgsrc + 'I_18.png',
            date:new Date(2016,3,28),
            preference: 4
        },
        {
            link:'http://www.businessinsider.in/Jugnoo-suspends-surge-pricing/articleshow/51943459.cms',
            desc:'Jugnoo suspends surge pricing for the second phase of Odd-Even rule ',
            img: imgsrc + 'I_18.png',
            date:new Date(2016,3,22),
            preference: 4
        },
        {
            link:'http://articles.economictimes.indiatimes.com/2016-04-22/news/72536377_1_surge-pricing-auto-aggregator-ola',
            desc:'Odd even scheme: After Ola, Uber, auto aggregator Jugnoo suspends surge pricing in Delhi ',
            img: imgsrc + 'I_2.png',
            date:new Date(2016,3,22),
            preference: 4
        },
        {
            link:'http://yourstory.com/2016/04/jugnoo-series_b-funding/',
            desc:'Jugnoo secures $10 M fresh round from Paytm, Snow Leopard and Rocketship.vc ',
            img: imgsrc + 'ys.png',
            date:new Date(2016,3,18),
            preference: 4
        },
        {
            link:'http://techcrunch.com/2016/04/18/indias-jugnoo-wraps-up-10m-series-b-for-uber-for-auto-rickshaws-service/',
            desc:'India’s Jugnoo wraps up $10M Series B for ‘Uber for auto-rickshaws’ service ',
            img: imgsrc + 'I_15.png',
            date:new Date(2016,3,18),
            preference: 4
        },
        {
            link:'http://www.financialexpress.com/article/india-news/on-demand-public-transport-providers-gearing-up-to-make-odd-even-rule-a-success/236886/',
            desc:'‘On demand’ public transport providers gearing up to make Odd-even rule a success ',
            img: imgsrc + 'I_4.png',
            date:new Date(2016,3,14),
            preference: 4
        },
        {
            link:'http://www.business-standard.com/article/companies/companies-get-ready-to-cash-in-on-odd-even-rule-116041400035_1.html',
            desc:'Companies get ready to cash in on odd-even rule ',
            img: imgsrc + 'I_1.png',
            date:new Date(2016,3,14),
            preference: 4
        },
        {
            link:'http://timesofindia.indiatimes.com/city/delhi/On-demand-travel-apps-become-hit-among-budget-backpackers/articleshow/51589746.cms',
            desc:'`On demand` travel apps become hit among budget backpackers ',
            img: imgsrc + 'toi.png',
            date:new Date(2016,2,28),
            preference: 4
        },
        {
            link:'http://www.financialexpress.com/article/lifestyle/travel-tourism/apps-to-ease-travel-woes/230187/',
            desc:'Apps to ease travel woes',
            img: imgsrc + 'toi.png',
            date:new Date(2016,2,28),
            preference: 4
   },        {
           link:'http://www.financialexpress.com/companies/jugnoo-launches-beat-the-heat-campaign-offers-users-free-sweet-treat-of-choice/253135/',
           desc:"Jugnoo launches Beat the Heat  campaign, offers users free sweet treat of choice",
           img: imgsrc + 'I_4.png',
           date:new Date(2016,4,12),
           preference: 4
       }
,        {
           link:'http://auto.economictimes.indiatimes.com/news/aftermarket/autorickshaw-aggregator-jugnoo-launches-campaign-to-relief-its-customers-from-summer-heat/52235355',
           desc:"Autorickshaw aggregator Jugnoo launches campaign to relief its customers from Summer heat",
           img: imgsrc + 'I_2.png',
           date:new Date(2016,4,12),
           preference: 4
       },        {
           link:'http://www.medianama.com/2016/05/223-jugnoo-fatafat-delivery/',
           desc:"Jugnoo to focus on Tier II cities for hyperlocal delivery business",
           img: imgsrc + 'I_2.png',
           date:new Date(2016,4,17),
           preference: 4
       },        {
           link:'http://economictimes.indiatimes.com/small-biz/startups/autorickshaw-aggregator-jugnoo-re-enters-hyperlocal-delivery-business/articleshow/52301690.cms',
           desc:"Autorickshaw aggregator Jugnoo re-enters hyperlocal delivery business",
           img: imgsrc + 'I_2.png',
           date:new Date(2016,4,17),
           preference: 4
       },        {
           link:'http://indianexpress.com/article/technology/tech-news-technology/jugnoo-travel-autorickshaw-helpchat-partnership-2818580/',
           desc:"Now book Jugnoo autorickshaws via Helpchat",
           img: imgsrc + 'techie-logo.png',
           date:new Date(2016,4,25),
           preference: 4
       },        {
           link:'https://www.entrepreneur.com/article/276422',
           desc:"Jugnoo Now Allows You To Book An Auto Via An AI Bot",
           img: imgsrc + 'I_27.png',
           date:new Date(2016,4,25),
           preference: 4
       },        {
           link:'https://www.entrepreneur.com/article/276837',
           desc:"Here's Why An Auto-Rickshaw Aggregator Acquired SabKuchFresh",
           img: imgsrc + 'I_27.png',
           date:new Date(2016,4,25),
           preference: 4
       },        {
           link:'http://www.newindianexpress.com/business/news/Jugnoo-acquires-SabKuchFresh-to-enhance-its-grocery-delivery-service-Fatafat/2016/06/03/article3464550.ece',
           desc:"Jugnoo acquires SabKuchFresh to enhance its grocery delivery service 'Fatafat'",
           img: imgsrc + 'Nie.jpg',
           date:new Date(2016,5,02),
           preference: 4
       }
,        {
           link:'http://economictimes.indiatimes.com/small-biz/startups/jugnoo-launches-auto-rickshaw-ride-pooling-service/articleshow/52591856.cms',
           desc:"Jugnoo launches auto-rickshaw ride pooling service",
           img: imgsrc + 'I_2.png',
           date:new Date(2016,5,03),
           preference: 4
       },        {
           link:'http://techcircle.vccircle.com/2016/06/03/jugnoo-rolls-out-auto-rickshaw-pooling-service/',
           desc:"Jugnoo rolls out auto-rickshaw pooling service",
           img: imgsrc + 'tcirc.png',
           date:new Date(2016,5,03),
           preference: 4
       },        {
           link:'http://tech.economictimes.indiatimes.com/news/startups/jugnoo-launches-multilingual-interface-for-auto-drivers/52639782',
           desc:"Jugnoo launches multilingual interface for auto drivers",
           img: imgsrc + 'ett.png',
           date:new Date(2016,5,07),
           preference: 4
       },        {
           link:'http://timesofindia.indiatimes.com/tech/tech-news/Jugnoo-launches-multilingual-interface-for-auto-drivers/articleshow/52636437.cms',
           desc:"Jugnoo launches multilingual interface for auto drivers",
           img: imgsrc + 'toi.png',
           date:new Date(2016,5,07),
           preference: 4
       },        {
           link:'http://www.thehindubusinessline.com/specials/emerging-entrepreneurs/jugnoo-acquires-subkuchfresh/article8724737.ece',
           desc:"Jugnoo acquires SubKuchFresh",
           img: imgsrc + 'toi.png',
           date:new Date(2016,5,13),
           preference: 4
       },        {
           link:'http://techcircle.vccircle.com/2016/06/20/jugnoo-ventures-into-b2b-logistics-with-dodo-deliveries/',
           desc:"Jugnoo ventures into B2B logistics with Dodo Deliveries",
           img: imgsrc + 'I_20.png',
           date:new Date(2016,5,20),
           preference: 4
       },        {
           link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-makes-booking-easier-with-hands-free-feature/52939849',
           desc:"Jugnoo makes booking easier with 'hands-free' feature",
           img: imgsrc + 'ETA.png',
           date:new Date(2016,5,27),
           preference: 4
       }
,        {
           link:'http://indianexpress.com/article/technology/tech-news-technology/jugnoo-ios-10-siri-book-auto-2879991/',
           desc:"In iOS 10, you’ll be able to call for an auto via Siri",
           img: imgsrc + 'techie-logo.png',
           date:new Date(2016,5,28),
           preference: 4
       }
,        {
           link:'http://www.financialexpress.com/industry/tech/jugnoo-unveils-house-route-optimization-software-flight-map/314379/',
           desc:"Jugnoo unveils in-house route optimization software 'Flight Map'",
           img: imgsrc + 'fe-logo.svg',
           date:new Date(2016,6,12),
           preference: 4
       },        {
           link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-unveils-in-house-route-optimization-software-flight-map/53174424',
           desc:"Jugnoo unveils in-house route optimization software 'Flight Map'",
           img: imgsrc + 'ETA.png',
           date:new Date(2016,6,12),
           preference: 4
       },        {
           link:'http://www.businessinsider.in/Jugnoo-COO-explains-why-any-delivery-based-startup-needs-their-latest-product/articleshow/53193061.cms',
           desc:"Jugnoo Tech Head explains why any delivery-based startup needs their latest product",
           img: imgsrc + 'BI.jpeg',
           date:new Date(2016,6,13),
           preference: 4
       },        {
           link:'http://www.business-standard.com/article/pti-stories/auto-rickshaw-aggregator-jugnoo-ties-up-with-trainman-116071300771_1.html',
           desc:"Auto-rickshaw aggregator Jugnoo ties up with Trainman",
           img: imgsrc + 'business_standard.jpeg',
           date:new Date(2016,6,13),
           preference: 4
       },        {
           link:'http://tech.economictimes.indiatimes.com/news/startups/auto-rickshaw-aggregator-jugnoo-ties-up-with-trainman/53203469',
           desc:"Auto-rickshaw aggregator Jugnoo ties up with Trainman",
           img: imgsrc + 'ett.png',
           date:new Date(2016,6,14),
           preference: 4
       },        {
           link:'http://www.financialexpress.com/industry/companies/jugnoo-launches-dodo-deliveries-in-gurgaon/324252/',
           desc:"Jugnoo launches ‘Dodo Deliveries’ in Gurgaon",
           img: imgsrc + 'fe-logo.svg',
           date:new Date(2016,6,21),
           preference: 4
       },        {
           link:'http://timesofindia.indiatimes.com/city/delhi/Jugnoo-launches-Dodo-Deliveries-in-Gurgaon/articleshow/53315981.cms',
           desc:"Jugnoo launches ‘Dodo Deliveries’ in Gurgaon",
           img: imgsrc + 'toi.png',
           date:new Date(2016,6,21),
           preference: 4
       },        {
           link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-pioneers-offline-auto-rickshaw-booking/53399040',
           desc:"Jugnoo pioneers offline auto-rickshaw booking",
           img: imgsrc + 'ETA.png',
           date:new Date(2016,6,26),
           preference: 4
       },        {
           link:'http://indianexpress.com/article/business/startups/jugnoo-files-a-patent-for-offline-auto-rickshaw-booking-2936204/',
           desc:"Jugnoo files a patent for offline auto rickshaw booking",
           img: imgsrc + 'ie.png',
           date:new Date(2016,6,26),
           preference: 4
       }
,        {
           link:'http://www.business-standard.com/article/companies/jugnoo-ties-up-with-mobikwik-to-power-digital-payments-across-37-cities-116080200630_1.html',
           desc:"Jugnoo ties up with MobiKwik to power digital payments across 37 cities",
           img: imgsrc + 'business_standard.jpeg',
           date:new Date(2016,7,02),
           preference: 4
       }
,        {
           link:'http://brandequity.economictimes.indiatimes.com/news/business-of-brands/jugnoo-joins-hands-with-mobikwik-to-provide-digital-payments-facility-across-35-cities/53524025',
           desc:"Jugnoo joins hands with MobiKwik to provide digital payments facility across 35 cities",
           img: imgsrc + 'ETB.png',
           date:new Date(2016,7,03),
           preference: 4
       },

        {
           link:'http://www.thehindubusinessline.com/info-tech/riding-the-pokemon-wave-auto-aggregator-jugnoo-integrates-app-with-mobile-game/article8948475.ece',
           desc:"Riding the Pokemon wave: Auto aggregator Jugnoo integrates app with mobile game",
           img: imgsrc + 'BL.jpg',
           date:new Date(2016,7,05),
           preference: 4
       },        {
           link:'http://www.financialexpress.com/industry/tech/enjoy-your-pokemon-go-mania-with-jugnoo/340649/',
           desc:"Enjoy your Pokemon Go-mania with Jugnoo",
           img: imgsrc + 'fe-logo.svg',
           date:new Date(2016,7,07),
           preference: 4
       },        {
           link:'http://techcircle.vccircle.com/2016/08/10/jugnoo-launches-lunch-delivery-service-to-boost-hyper-local-grocery-platform-fatafat/',
           desc:"Jugnoo launches lunch delivery service to boost hyper-local grocery platform Fatafat",
           img: imgsrc + 'tcirc.png',
           date:new Date(2016,7,10),
           preference: 4
       },        {
           link:'http://indianexpress.com/article/lifestyle/food-wine/not-just-comfortable-auto-rikshaw-rides-jugnoo-now-offers-delicious-meals-at-your-doorsteps/',
           desc:"Not just comfortable auto-rickshaw rides, Jugnoo now offers delicious meals at your doorsteps",
           img: imgsrc + 'ie.png',
           date:new Date(2016,7,12),
           preference: 4
       }
,        {
           link:'http://www.thehindu.com/todays-paper/tp-national/tp-karnataka/meet-veena-first-woman-auto-driver-to-enrol-with-an-aggregator-in-mysuru/article9001530.ece',
           desc:"Meet Veena, first woman auto driver to enrol with an aggregator in Mysuru",
           img: imgsrc + 'I_20.png',
           date:new Date(2016,7,18),
           preference: 4
       },
    {
        link: 'http://mybigplunge.com/video/jugnoo-can-put-a-stop-to-your-auto-rickshaw-wars/',
        desc: 'Jugnoo can put a stop to your Daily Auto Rickshaw Wars.',
        img: imgsrc + 'mybigplunge-logo.png',
        date: new Date(2016, 8, 23),
        preference: 4
    },
    {
        link: 'http://economictimes.indiatimes.com/small-biz/startups/jugnoo-in-talks-with-leading-ecommerce-firms-for-delivery-service/articleshow/54366421.cms',
        desc: 'Jugnoo in talks with leading ecommerce firms for delivery service ',
        img: imgsrc + 'I_2.png',
        date: new Date(2016, 8, 17),
        preference: 4
    },
    {
        link: 'http://www.business-standard.com/article/news-ani/jugnoo-freecharge-tie-up-to-ease-payment-processes-116091600190_1.html',
        desc: 'Jugnoo, Freecharge tie-up to ease payment processes ',
        img: imgsrc + 'I_1.png',
        date: new Date(2016, 8, 16),
        preference: 4
    },
    {
        link: 'http://bwdisrupt.businessworld.in/article/Committed-to-Promote-Cashless-Commute-Pan-India-Jugnoo-Partners-With-Freecharge/15-09-2016-105680/',
        desc: 'Committed to Promote Cashless Commute Pan India, Jugnoo Partners With Freecharge ',
        img: imgsrc + 'full-Disrupt-logo.jpg',
        date: new Date(2016, 8, 15),
        preference: 4
    },
    {
        link: 'http://www.business-standard.com/article/news-ani/jugnoo-bags-api-world-2016-award-in-transportation-api-116091400408_1.html',
        desc: "Jugnoo bags 'API World 2016 Award' in transportation API ",
        img: imgsrc + 'I_1.png',
        date: new Date(2016, 8, 14),
        preference: 4
    },
    {
        link: 'http://www.businessinsider.in/Jugnoo-and-its-new-logistics-verticles-Dodo-and-Fatafat/articleshow/54329702.cms',
        desc: "Is your next delivery boy also an autowallah? It's because of Jugnoo ",
        img: imgsrc + 'I_18.png',
        date: new Date(2016, 8, 14),
        preference: 4
    },
    {
        link: 'http://economictimes.indiatimes.com/jobs/jugnoo-where-interns-are-encouraged-to-be-intrapreneurs/articleshow/54024118.cms',
        desc: "Jugnoo: Where interns are encouraged to be intrapreneurs ",
        img: imgsrc + 'I_2.png',
        date: new Date(2016, 8, 6),
        preference: 4
    },
    {
        link: 'http://auto.economictimes.indiatimes.com/news/aftermarket/auto-rickshaw-aggregator-jugnoo-bags-start-up-of-the-year-award/53992289',
        desc: "Auto rickshaw aggregator Jugnoo bags 'Start-up of the Year' award ",
        img: imgsrc + 'I_2.png',
        date: new Date(2016, 8, 3),
        preference: 4
    },
    {
        link: 'http://www.business-standard.com/article/news-ani/jugnoo-introduces-unified-payment-interface-upholding-cashless-economy-116090200982_1.html',
        desc: "Jugnoo introduces Unified Payment Interface upholding cashless economy ",
        img: imgsrc + 'I_1.png',
        date: new Date(2016, 8, 2),
        preference: 4
    },
    {
        link: 'http://forbesindia.com/article/work-in-progress/jugnoos-new-avenues-of-profit/44155/1',
        desc: "Jugnoo's new avenues of profit",
        img: imgsrc + 'forber-logo.jpg',
        date: new Date(2016, 7, 31),
        preference: 4
    },
    {
        link: 'https://inc42.com/startups/jugnoo-growth-story/',
        desc: "20+ Months, 20+ Innovations, 20% M-O-M Growth: How Jugnoo Is Killing It In Daily Commute Space",
        img: imgsrc + 'inc.png',
        date: new Date(2016, 7, 30),
        preference: 4
    },

    {
        link: 'http://timesofindia.indiatimes.com/city/pune/Jugnoo-autorickshaw-aggregator-launches-web-booking-feature/articleshow/54567926.cms',
        desc: "Jugnoo, autorickshaw aggregator, launches web booking feature",
        img: imgsrc + 'toi.png',
        date: new Date(2016, 8, 28),
        preference: 4
    },
    {
        link: 'http://www.business-standard.com/article/news-ani/jugnoo-launches-web-booking-feature-116092801009_1.html',
        desc: "Jugnoo launches 'Web booking' feature",
        img: imgsrc + 'I_1.png',
        date: new Date(2016, 8, 28),
        preference: 4
    },
    {
        link: 'http://www.business-standard.com/article/news-ani/jugnoo-offers-its-b2b-logistics-service-in-major-metropolis-116100500629_1.html',
        desc: "Jugnoo offers its B2B logistics service in major metropolis",
        img: imgsrc + 'I_1.png',
        date: new Date(2016, 9, 5),
        preference: 4
    },
    {
        link: 'http://bwdisrupt.businessworld.in/article/Exponentially-Expanding-Its-Operational-Territory-Jugnoo-Offers-Its-B2B-Logistics-Service-in-Major-Metropolis/05-10-2016-106595/',
        desc: "Exponentially Expanding Its Operational Territory, Jugnoo Offers Its B2B Logistics Service in Major Metropolis",
        img: imgsrc + 'full-Disrupt-logo.jpg',
        date: new Date(2016, 9, 5),
        preference: 4
    },
    {
        link: 'http://www.indiaretailing.com/2016/10/10/retail/dodo-deliveries-rebrands-jugnoo-delivery-plans-expansion/',
        desc: "Dodo Deliveries rebrands into Jugnoo Delivery, plans expansion",
        img: imgsrc + 'indiaretailing-logo.jpg',
        date: new Date(2016, 9, 10),
        preference: 4
    },
    {
        link: 'http://www.thehindubusinessline.com/companies/logistics-services-drive-growth-for-autorickshaw-app-jugnoo/article9235802.ece',
        desc: "Logistics services drive growth for auto-rickshaw app Jugnoo",
        img: imgsrc + 'I_18.png',
        date: new Date(2016, 9, 18),
        preference: 4
    },
    {
        link: 'https://inc42.com/flash-feed/jugnoo-grocery-delivery/',
        desc: "On Demand Auto Rickshaw Aggregator Jugnoo Launches Grocery Delivery Service",
        img: imgsrc + 'inc.png',
        date: new Date(2016, 9, 20),
        preference: 4
    },
    {
        link: 'http://www.financialexpress.com/industry/companies/now-get-your-groceries-delivered-by-auto-aggregator-jugnoo/425593/',
        desc: "Now, get your groceries delivered by auto-aggregator Jugnoo",
        img: imgsrc + 'I_4.png',
        date: new Date(2016, 9, 20),
        preference: 4
    },
    {
        link: 'http://www.asianage.com/people/rickshow-goes-quirkily-098',
        desc: "This Rickshaw goes on, quirkily",
        img: imgsrc + 'asianage_logo.jpg',
        date: new Date(2016, 9, 26),
        preference: 4
    },

    {
        link:'http://www.dailyindian.com/2016/12/22/nobody-remembers-your-failuers-once-you-succeed/',
        desc:"Nobody remembers your failures once you succeed",
        img: imgsrc + 'daily_indian.png',
        date:new Date(2016,11,22),
        preference: 0
    },

    {
        link:'http://www.fnbnews.com/Top-News/jugnoo-launches-readytoeat-food-delivery-service-meals-in-gurugram-39988',
        desc:"Jugnoo launches ready-to-eat food delivery service Meals in Gurugram",
        img: imgsrc + 'fnbnews.png',
        date:new Date(2017,0,2),
        preference: 0
    },

    {
        link:'https://www.hungryforever.com/jugnoos-ready-eat-food-delivery-system-comes-gurgaon/',
        desc:"Jugnoo’s Ready-To-Eat Food Delivery System Comes To Gurgaon",
        img: imgsrc + 'hungryforever.png',
        date:new Date(2017,0,2),
        preference: 0
    },

    {
        link:'http://zeenews.india.com/apps/jugnoo-enables-upi-payments-on-its-apps_1964557.html',
        desc:"Jugnoo enables UPI payments on its apps",
        img: imgsrc + 'zeenews.png',
        date:new Date(2017,0,5),
        preference: 0
    },

    {
        link:'http://www.thehindubusinessline.com/companies/announcements/others/jugnoo-enables-upi-payments-powered-by-yes-bank-on-its-app/article9460726.ece',
        desc:"Jugnoo enables UPI payments powered by YES BANK on its app",
        img: imgsrc + 'I_18.png',
        date:new Date(2017,0,5),
        preference: 0
    },

    {
        link:'http://www.indiaretailing.com/2017/01/10/food/food-service/jugnoo-expands-meal-category-midnight-delivery-service/',
        desc:"Jugnoo expands meal category with midnight delivery service",
        img: imgsrc + 'indiaretailing-logo.jpg',
        date:new Date(2017,0,10),
        preference: 0
    },

    {
        link:'http://www.financialexpress.com/industry/auto-rickshaw-aggregator-jugnoo-enters-midnight-food-delivery-service-to-offer-punjabi-mughlai-other-fare-at-reasonable-rates/502455/',
        desc:"Auto rickshaw aggregator Jugnoo enters midnight food delivery service; to offer Punjabi, Mughlai, other fare at ‘reasonable rates’",
        img: imgsrc + 'I_4.png',
        date:new Date(2017,0,10),
        preference: 0
    },

    {
        link:'http://www.business-standard.com/article/news-ani/adding-yet-another-feather-in-the-cap-jugnoo-launches-menus-117011300545_1.html',
        desc:"Adding yet another feather in the cap, Jugnoo launches Menus",
        img: imgsrc + 'I_1.png',
        date:new Date(2017,0,13),
        preference: 0
    },

    {
        link:'http://www.financialexpress.com/industry/adding-yet-another-feather-in-the-cap-jugnoo-launches-menus/506803/',
        desc:"Adding yet another feather in the cap, Jugnoo launches Menus",
        img: imgsrc + 'I_4.png',
        date:new Date(2017,0,13),
        preference: 0
    },

    {
        link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-unveils-its-new-brand-logo/56642985',
        desc:"Jugnoo unveils its new brand logo",
        img: imgsrc + 'I_2.png',
        date:new Date(2017,0,18),
        preference: 0
    },

    {
        link:'http://mybigplunge.com/news/news-flash/jugnoo-has-assumed-a-new-brand-identity-india-market-leader-hyperlocal-space/',
        desc:"Jugnoo has assumed a new brand identity; hopes to be India’s market leader in hyperlocal space",
        img: imgsrc + 'mybigplunge-logo.png',
        date:new Date(2017,0,18),
        preference: 0
    },

    {
        link:'http://auto.economictimes.indiatimes.com/news/aftermarket/jugnoo-partners-yatra-for-last-mile-connectivity-to-travellers/56735779',
        desc:"Jugnoo partners Yatra for last mile connectivity to travellers",
        img: imgsrc + 'I_2.png',
        date:new Date(2017,0,23),
        preference: 0
    },

    {
        link:'http://www.business-standard.com/article/news-ani/jugnoo-announces-exclusive-partnership-with-yatra-com-117012300529_1.html',
        desc:"Jugnoo announces exclusive partnership with Yatra.com",
        img: imgsrc + 'I_1.png',
        date:new Date(2017,0,23),
        preference: 0
    },
    {
        link:'http://www.cityairnews.com/content/subscribe-jugnoo-star-great-deals-and-discounts',
        desc:"Subscribe to Jugnoo Star for great deals and discounts",
        img: imgsrc + 'city-air-logo.jpeg',
        date:new Date(2017,0,25),
        preference: 0
    },
    {
        link:'http://www.deccanherald.com/content/595848/bengalurus-first-delivery-girl-flies.html',
        desc:"Bengaluru's first delivery girl flies with wings of fire",
        img: imgsrc + 'DH-Logo.jpg',
        date:new Date(2017,1,11),
        preference: 0
    },
    {
        link:'http://www.newindianexpress.com/business/2017/feb/12/multi-service-provider-jugnoo-to-venture-into-taxi-aggregation-business-amidst-ola-uber-strike-1569893.html',
        desc:"Multi-service provider Jugnoo to venture into taxi aggregation business amidst Ola, Uber strike",
        img: imgsrc + 'Nie.jpg',
        date:new Date(2017,1,12),
        preference: 0
    },
    {
        link:'https://www.bloombergquint.com/business/2017/02/12/jugnoo-forays-into-taxi-aggregation-amid-ongoing-strike-by-uber-ola-drivers',
        desc:"Jugnoo Forays Into Taxi Aggregation Amid Ongoing Strike By Uber, Ola Drivers",
        img: imgsrc + 'bloomberg.jpg',
        date:new Date(2017,1,13),
        preference: 0
    },
    {
        link:'http://www.livemint.com/Companies/HMLL4PaXPWRXblchAXizLO/Online-autorickshaw-aggregator-Jugnoo-launches-taxi-service.html',
        desc:"Online autorickshaw aggregator Jugnoo launches taxi service",
        img: imgsrc + 'livemint.png',
        date:new Date(2017,1,13),
        preference: 0
    },
    {
        link:'http://www.financialexpress.com/industry/as-uber-ola-strike-hits-bengaluru-hard-jugnoo-plans-to-take-advantage-roll-out-auto-hailing-business-in-april/556313/',
        desc:"As Uber, Ola strike hits Bengaluru hard, Jugnoo plans to take advantage, roll-out auto-hailing business in April",
        img: imgsrc + 'I_4.png',
        date:new Date(2017,1,18),
        preference: 0
    },
    {
        link:'https://www.entrepreneur.com/article/289590',
        desc:"Jugnoo's Growth Journey From Auto-rickshaw to Hyperlocal Commerce",
        img: imgsrc + 'I_27.png',
        date:new Date(2017,1,23),
        preference: 0
    },
    {
        link:'http://www.dqindia.com/jugnoo-unveils-its-in-house-technology-data-loops/',
        desc:"Jugnoo unveils its in-house technology ‘Data Loops’",
        img: imgsrc + 'dq-logo.png',
        date:new Date(2017,2,6),
        preference: 0
    },
    {
        link:'http://www.dqchannels.com/breaking-stereotypes-jugnoo-celebrates-womens-day-with-a-powerful-message/',
        desc:"Jugnoo Breaking Stereotypes : Celebrating Women’s Day with a powerful message",
        img: imgsrc + 'dq_channel_logo.png',
        date:new Date(2017,2,7),
        preference: 0
    }

    ];
           
           
           
           
    $scope.videoArchive = [
    {
        link:"https://www.youtube.com/embed/be27a8DKb_M",
        desc:"Samar Singla on how he conceptualized Jugnoo to solve both driver issues as well as commuter problems."
    },
    {
        link:"https://www.youtube.com/embed/ZoDHTOhBFws",
        desc:"Isha Singla on how Jugnoo was launched to resolve immediate problems in public transport."
    },
        {
            link:"https://www.youtube.com/embed/bt7BgwdFgsw",
            desc:"Samar Singla on How to not only survive but also grow against billion-dollar gorillas."
        },
        {
            link:"https://www.youtube.com/embed/Nf0a3wTCgqw",
            desc:"Samar Singla on the importance of crowdsourcing at the Crowdsourcing Week in Brussels."
        },
        {
            link:"https://www.youtube.com/embed/RjB3zuhKOF8",
            desc:"Samar Singla expressing his view on Budget 2016 with regards to start-ups like Jugnoo."
        },
        {
            link:"https://www.youtube.com/embed/sBiurXOif3Q",
            desc:"The interesting role Jugnoo app plays in the ongoing Odd-Even Formula of Delhi."
        },
        {
            link:"https://www.youtube.com/embed/hOUI_3zAYe4",
            desc:"An auto rickshaw driver giving his inputs on how Jugnoo app makes life easier for him."
        },
        {
            link:"https://www.youtube.com/embed/ZBTXD5JKN1c",
            desc:"Samar Singla elaborates on how his venture is increasing efficiency and making transformational changes in the lives of auto rickshaw drivers across India."
        },
        {
            link:"https://www.youtube.com/embed/Ci9TQkcRuRo",
            desc:"Samar Singla elaborates on how his venture is increasing efficiency and making transformational changes in the lives of auto rickshaw drivers across India."
        }
    ];
           $scope.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
    }   
           
           
        }]);    

